import { Icon } from "@/assets/icons";
import { saveAs } from "file-saver";
import React, { useMemo } from "react";
import { MdOutlineFileDownload } from "react-icons/md";
import { FileIcon } from "../FileIcon";

interface FileItemProps {
  url: string;
  name: string;
  type: string;
}

const FileItem: React.FC<FileItemProps> = ({ url, name, type }) => {
  const handleDownload = () => {
    // Open file in a new tab
    saveAs(url, name);
  };

  const ext = useMemo(() => {
    return type.split("/").pop();
  }, [type]);

  return (
    <div className="bg-[#F5F6F9] p-4 rounded-lg inline-flex items-center gap-4 w-fit max-w-full">
      <div className="shrink-0">
        {type === "application/pdf" ? (
          <Icon name="pdf" className="shrink-0 size-6" />
        ) : (
          <FileIcon url={url} fileName={name} ext={ext} isDownload={false} />
        )}
      </div>

      <div
        className="line-clamp-1 truncate text-sm text-light_primary"
        title={name}
      >
        {name}
      </div>

      <MdOutlineFileDownload
        className="text-light_secondary size-6 shrink-0 cursor-pointer hover:text-cyan"
        onClick={handleDownload}
      />
    </div>
  );
};

export { FileItem };
